export default __webpack_public_path__ + "static/media/wwr-bg.474696dc.webp";